import { LoadablePaint } from '@confluence/loadable';

export const SearchExtensionLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SearchExtension" */ './SearchExtension'))
			.SearchExtension,
});
